"use client";

import React, { useState, useEffect } from "react";

const videos = [
  "/contact/balls.mp4",
  "/contact/bubble.mp4",
  "/contact/circles.mp4",
  // "/contact/contact.mp4",
  "/contact/paper.mp4",
  "/contact/squah.mp4",
  "/contact/squish.mp4",
];

const ContactBackground: React.FC = () => {
  const [selectedVideo, setSelectedVideo] = useState<string>("");

  useEffect(() => {
    // Randomly select a video on component mount
    const randomIndex = Math.floor(Math.random() * videos.length);
    setSelectedVideo(videos[randomIndex]);
  }, []);

  // Don't render video until one is selected (prevents hydration mismatch)
  if (!selectedVideo) {
    return (
      <div className="absolute inset-0">
        <div className="absolute inset-0 w-full h-full bg-gradient-to-t from-bg-dark to-transparent" />
        <div className="absolute inset-0 w-full h-full bg-gradient-to-b from-bg-dark to-transparent" />
      </div>
    );
  }

  return (
    <div className="absolute inset-0">
      <video
        key={selectedVideo}
        className="h-full w-full object-cover"
        autoPlay={true}
        loop
        playsInline={true}
        muted
        preload="auto"
      >
        <source src={selectedVideo} type="video/mp4" />
      </video>
      <div className="absolute inset-0 w-full h-full bg-gradient-to-t from-bg-dark to-transparent " />
      <div className="absolute inset-0 w-full h-full bg-gradient-to-b from-bg-dark to-transparent " />
    </div>
  );
};

export default ContactBackground;
